// Interne Notizen am Thread (Phase 3): nur fürs Team, nie in der Mail. Einträge von „system“ kommen
// von Vertretung und Regeln.
import { useCallback, useEffect, useState } from 'react';
import { TEAM, isUserKey } from '@mail/shared';
import { api, type NotizRow } from '../lib/api.ts';
import { fmtWhen } from '../lib/format.ts';
import { onThreadsChanged, useStore } from '../lib/store.ts';
import { toast } from './Toast.tsx';

export function Notizen({ threadId }: { threadId: number }) {
  const me = useStore((s) => s.me);
  const [list, setList] = useState<NotizRow[]>([]);
  const [text, setText] = useState('');
  const [open, setOpen] = useState(false);
  const load = useCallback(
    () =>
      api
        .notizen(threadId)
        .then((r) => setList(r.notizen))
        .catch(() => setList([])),
    [threadId],
  );
  useEffect(() => void load(), [load]);
  useEffect(
    () => onThreadsChanged((ids) => (ids.includes(threadId) ? void load() : undefined)),
    [threadId, load],
  );
  const add = async () => {
    const t = text.trim();
    if (!t) return;
    try {
      await api.notizAnlegen(threadId, t);
      setText('');
      setOpen(false);
      void load();
    } catch (e) {
      toast((e as Error).message);
    }
  };
  const name = (k: string) => (k === 'system' ? 'System' : isUserKey(k) ? TEAM[k].name : k);
  if (!list.length && !open)
    return (
      <button
        className="btn ghost sm notiz-add"
        onClick={() => setOpen(true)}
        title="Interne Notiz (nur fürs Team)"
      >
        ✎ Notiz
      </button>
    );
  return (
    <div className="notizen" aria-label="Interne Notizen">
      {list.map((n) => (
        <div key={n.id} className={`notiz${n.user === 'system' ? ' sys' : ''}`}>
          <div className="notiz-h">
            <b>{name(n.user)}</b> <span className="muted">{fmtWhen(n.am)}</span>
            {n.user === me?.key && (
              <button
                className="notiz-x"
                aria-label="Notiz löschen"
                onClick={() => void api.notizLoeschen(threadId, n.id).then(load)}
              >
                ✕
              </button>
            )}
          </div>
          <div className="notiz-t">{n.text}</div>
        </div>
      ))}
      {open ? (
        <div className="notiz-neu">
          <textarea
            autoFocus
            rows={2}
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder="Interne Notiz – sieht nur das Team"
            onKeyDown={(e) => {
              if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) void add();
              if (e.key === 'Escape') setOpen(false);
            }}
          />
          <div style={{ display: 'flex', gap: 6 }}>
            <button className="btn sm pri" onClick={() => void add()} disabled={!text.trim()}>
              Speichern
            </button>
            <button className="btn sm ghost" onClick={() => setOpen(false)}>
              Abbrechen
            </button>
          </div>
        </div>
      ) : (
        <button
          className="btn ghost sm notiz-add"
          onClick={() => setOpen(true)}
          title="Interne Notiz (nur fürs Team)"
        >
          ✎ Notiz
        </button>
      )}
    </div>
  );
}
